import { FGIcon } from '@components/icons/FGIcon'
import { FlexRow } from '@components/shared/FlexRow'
import { CurrencyFormat, DecimalFormat, PercentFormat } from '@components/shared/Format'
import { FormField, SelectOption } from '@components/shared/FormField'
import { GoldCard } from '@components/shared/GoldCard'
import { I18n } from '@components/shared/I18n'
import { Table, TableCell, TableRow } from '@components/shared/Table'
import { CountryInfoUrlKey } from '@models/CountryInfo'
import { SectionComponent, SectionKey } from '@sections/SectionComponent'
import { StoreProps } from '@stores/Store'
import { I18nKey } from '@utils/i18n'
import { leadershiPlusIncentiveFqGrowthOptions, leadershiPlusIncentiveLevelAchievedOptions, LeadershipPlusFqGrowthValue, LeadershipPlusLevelAchievedValue } from '@utils/sections/LeadershipPlusIncentive.util'
import { Form } from 'antd'
import { inject, observer } from 'mobx-react'
import React from 'react'

interface LeadershipPlusIncentiveFormData {
  leadershipPlusIncentiveLevelAchieved?: LeadershipPlusLevelAchievedValue
  leadershipPlusIncentiveFqGrowth?: LeadershipPlusFqGrowthValue
}

@inject('store')
@observer
export class LeadershipPlusIncentiveSection extends SectionComponent<StoreProps, {}> {
  static defaultProps = {} as StoreProps
  static get title(): I18nKey { return 'SECTION_LEADERSHIP_PLUS_INCENTIVE' }
  static get icon() { return <FGIcon /> }
  static get trackerKey() { return 'C+leadership' }

  onValuesChange = (data: LeadershipPlusIncentiveFormData) => {
    const { store } = this.props
    const { leadershipPlusIncentiveStore } = store
    if ('leadershipPlusIncentiveLevelAchieved' in data) { leadershipPlusIncentiveStore.setLeadershipPlusIncentiveLevelAchieved(data.leadershipPlusIncentiveLevelAchieved!) }
    if ('leadershipPlusIncentiveFqGrowth' in data) { leadershipPlusIncentiveStore.setLeadershipPlusIncentiveFqGrowth(data.leadershipPlusIncentiveFqGrowth!) }
    store.globalStore.updateSectionUsage(SectionKey.LEADERSHIP_PLUS_INCENTIVE)
  }

  render() {
    const { store } = this.props
    const { leadershipPlusIncentiveStore } = store
    const { leadershipPlusIncentive, leadershipPlusIncentiveAnnualPPVRequirement, leadershipPlusIncentiveAnnualRubyPVRequirement,
      leadershipPlusIncentiveAnnualMultipier, leadershipPlusIncentivePaymentCap } = store.leadershipPlusIncentiveCalculation
    const { leadershipPlusIncentiveLevelAchieved, leadershipPlusIncentiveFqGrowth } = leadershipPlusIncentiveStore
    const levelAchievedOptions: SelectOption<LeadershipPlusLevelAchievedValue>[] = leadershiPlusIncentiveLevelAchievedOptions()
    const fqGrowthOptions: SelectOption<LeadershipPlusFqGrowthValue>[] = leadershiPlusIncentiveFqGrowthOptions()

    return (
      <>
        <Form className='section' layout='vertical'
          initialValues={{ leadershipPlusIncentiveLevelAchieved, leadershipPlusIncentiveFqGrowth }}
          onValuesChange={this.onValuesChange}>
          <FlexRow collapse>
            <FormField name="leadershipPlusIncentiveLevelAchieved" type='select' label='LEVEL_ACHIEVED_PY' options={levelAchievedOptions} />
            <FormField name="leadershipPlusIncentiveFqGrowth" type='select' label='FQ_GROWTH' options={fqGrowthOptions} />
          </FlexRow>
        </Form>
        <Table className='section section-full-width'>
          <TableRow>
            <TableCell><I18n name='ANNUAL_PPV_REQUIREMENT' /></TableCell>
            <TableCell align='right'><DecimalFormat value={leadershipPlusIncentiveAnnualPPVRequirement}></DecimalFormat></TableCell>
          </TableRow>
          <TableRow>
            <TableCell><I18n name='ANNUAL_RUBY_PV_REQUIREMENT' /></TableCell>
            <TableCell align='right'><DecimalFormat value={leadershipPlusIncentiveAnnualRubyPVRequirement}></DecimalFormat></TableCell>
          </TableRow>
          <TableRow>
            <TableCell width={220}><I18n name='ANNUAL_MULTIPLIER_ON_LEADERSHIP' /></TableCell>
            <TableCell align='right'><PercentFormat value={leadershipPlusIncentiveAnnualMultipier}></PercentFormat></TableCell>
          </TableRow>
          <TableRow>
            <TableCell><I18n name='PAYMENT_CAP' /></TableCell>
            <TableCell align='right'><CurrencyFormat value={leadershipPlusIncentivePaymentCap}></CurrencyFormat></TableCell>
          </TableRow>
        </Table>
        <div className='section section-rewards'>
          {leadershipPlusIncentive === 0 ? (
            <GoldCard title='CP_LEADERSHIP_PLUS_INCENTIVE_DISABLED' disabled infoUrl={CountryInfoUrlKey.INFO_LEADERSHIP_PLUS_INCENTIVE_URL}></GoldCard>
          ) : (
            <GoldCard title='CP_LEADERSHIP_PLUS_INCENTIVE' value={leadershipPlusIncentive} period='PER_YEAR'></GoldCard>
          )}
        </div>
      </>
    )
  }
}

